import type { FC, ReactNode } from 'react'
import { Link } from 'react-router-dom'
import type { CmsLink } from '../../types/cmsLink'

interface CmsLinkComponentProps {
    link: CmsLink
    onClick?: () => void
    className?: string
    children?: ReactNode
}

export const CmsLinkComponent: FC<CmsLinkComponentProps> = ({ link, className, children, onClick = () => {} }) => {
    if (!link) return null

    /**
     * Sometimes users may input a link starting with `www`, e.g., `www.google.com`.
     * In such cases, ensure it is converted to a new URL by prepending `https://`.
     *
     * so that it won't be appended on the url
     */
    let { url } = link
    url = /^www./.test(url) ? `https://${url}` : url

    return (
        <Link to={url} target={link.target} className={className} onClick={onClick}>
            {!children && link.name}
            {children}
        </Link>
    )
}
